"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveDomain = void 0;
var api_utils_1 = require("@moralisweb3/api-utils");
var evm_utils_1 = require("@moralisweb3/evm-utils");
exports.resolveDomain = (0, api_utils_1.createEndpointFactory)(function (core) {
    return (0, api_utils_1.createEndpoint)({
        name: 'resolveDomain',
        urlParams: ['domain'],
        getUrl: function (params) { return "/resolve/".concat(params.domain); },
        apiToResult: function (data) { return ({
            address: evm_utils_1.EvmAddress.create(data.address, core),
        }); },
        resultToJson: function (data) { return ({
            address: data.address.format(),
        }); },
        parseParams: function (params) { return params; },
    });
});
//# sourceMappingURL=resolveDomain.js.map